import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  showDashboardButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ showDashboardButton = false }) => {
  const { user } = useAuth();

  return (
    <div className="navbar bg-base-100 shadow-lg">
      <div className="navbar-start">
        <Link to="/" className="btn btn-ghost text-xl">SuprHR</Link>
      </div>
      <div className="navbar-end">
        {showDashboardButton && user ? (
          <Link to="/dashboard" className="btn btn-primary">Go to Dashboard</Link>
        ) : (
          <Link to="/" className="btn btn-ghost">← Back to Home</Link>
        )}
      </div>
    </div>
  );
}; 